import React from "react";
const drivers = [
  {
    id: 1,
    imgUrl:
      "https://cdn.pmlsound.com/anthem/avm90/images/drivers/crestron_logo.png",
  },
  {
    id: 2,
    imgUrl:
      "https://cdn.pmlsound.com/anthem/avm90/images/drivers/control4-vector-logo.png",
  },
  {
    id: 3,
    imgUrl:
      "https://cdn.pmlsound.com/anthem/avm90/images/drivers/savant_logo.png",
  },
  {
    id: 4,
    imgUrl: "https://cdn.pmlsound.com/anthem/avm90/images/drivers/urc_logo.png",
  },
  {
    id: 5,
    imgUrl: "https://cdn.pmlsound.com/anthem/avm90/images/drivers/rti_logo.png",
  },
  {
    id: 6,
    imgUrl:
      "https://cdn.pmlsound.com/anthem/avm90/images/drivers/elan_logo.png",
  },
];
const Integration = () => {
  return (
    <>
      <section className="z-50 relative hidden lg:block" id="integration">
        <div className="h-screen relative z-30 flex  justify-center items-center bg-black overflow-hidden py-12 px-6 md:py-20 ">
          <video
            id="integration"
            width="100%"
            autoPlay
            loop
            muted
            playsInline
            className="absolute z-0 w-full scale-[2] md:scale-[2] lg:scale-150"
          >
            <source
              src="https://cdn.pmlsound.com/anthem/avm90/videos/integrate-with-ease-hd_22.mp4"
              type="video/mp4"
            />
          </video>

          <div className=" w-full max-w-3xl mx-auto text-white text-center">
            <div className=" inset-x-0 bottom-0 w-full">
              <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center  text-white leading-snug drop-shadow-lg">
                Integrate with Ease
              </h4>
              <p class="text-2xl  mt-10 font-light text-center justify-center drop-shadow-lg">
                At Anthem, we pride ourselves on playing nice with others, no
                matter the ask. As a result, we've made the Anthem AVM 90 the
                ultimate nerve center for any premium home theatre or media room
                by treating ease of integration as a top priority. The Anthem
                AVM 90 features RS232 Serial and IP control capabilities for
                easy customization and compatibility with common third-party
                integration solutions.
              </p>

              <div className="relative ">
                <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-6 lg:px-8">
                  <div className="mt-6 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-8">
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                      <img
                        className="max-h-6 mt-3"
                        src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/crestron_logo.png"
                        alt="Workcation"
                      />
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50 ">
                      <img
                        className="max-h-12"
                        src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/control4-vector-logo.png"
                        alt="Mirage"
                      />
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                      <img
                        className="max-h-6 mt-3"
                        src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/savant_logo.png"
                        alt="Tuple"
                      />
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                      <img
                        className="max-h-9 mt-2"
                        src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/urc_logo.png"
                        alt="Laravel"
                      />
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                      <img
                        className="max-h-10 mt-2 "
                        src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/rti_logo.png"
                        alt="StaticKit"
                      />
                    </div>
                    <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                      <img
                        className="max-h-6 mt-3"
                        src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/elan_logo.png"
                        alt="Statamic"
                      />
                    </div>
                    {/* {drivers.map((_) => {
                    return (
                      <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                        <img
                          className="max-h-10"
                          src={_.imgUrl}
                          alt="Workcation"
                          width="100%"
                          height="100%"
                        />
                      </div>
                    );
                  })} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="z-50 relative block md:hidden">
        <div
          className="bg-black py-12 px-5 md:py-20 bg-no-repeat bg-cover"
          style={{
            backgroundImage:
              "url(" +
              "https://cdn.pmlsound.com/anthem/avm90/images/integration-mobile.png" +
              ")",
            backgroundPosition: "center",
          }}
        >
          <div className="max-w-7xl mx-auto  " id="streaming_options">
            <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center  text-white leading-snug z-50">
              Integrate with Ease
            </h4>

            <p className="text-xl  font-light text-center  text-white  mt-10">
              At Anthem, we pride ourselves on playing nice with others, no
              matter the ask. As a result, we've made the Anthem AVM 90 the
              ultimate nerve center for any premium home theatre or media room
              by treating ease of integration as a top priority. The Anthem AVM
              90 features RS232 Serial and IP control capabilities for easy
              customization and compatibility with common third-party
              integration solutions.
            </p>
            <div className="relative ">
              <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-6 lg:px-8">
                <div className="mt-6 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-8">
                  <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                    <img
                      className="max-h-6 mt-3"
                      src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/crestron_logo.png"
                      alt="Workcation"
                    />
                  </div>
                  <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50 ">
                    <img
                      className="max-h-12"
                      src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/control4-vector-logo.png"
                      alt="Mirage"
                    />
                  </div>
                  <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                    <img
                      className="max-h-6 mt-3"
                      src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/savant_logo.png"
                      alt="Tuple"
                    />
                  </div>
                  <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                    <img
                      className="max-h-9 mt-2"
                      src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/urc_logo.png"
                      alt="Laravel"
                    />
                  </div>
                  <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                    <img
                      className="max-h-10 mt-2 "
                      src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/rti_logo.png"
                      alt="StaticKit"
                    />
                  </div>
                  <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                    <img
                      className="max-h-6 mt-3"
                      src="https://cdn.pmlsound.com/anthem/avm90/images/drivers/elan_logo.png"
                      alt="Statamic"
                    />
                  </div>
                  {/* {drivers.map((_) => {
                    return (
                      <div className="col-span-1 flex justify-center py-8 px-8 bg-gray-50">
                        <img
                          className="max-h-10"
                          src={_.imgUrl}
                          alt="Workcation"
                          width="100%"
                          height="100%"
                        />
                      </div>
                    );
                  })} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Integration;
